module.exports = __webpack_public_path__ + "fonts/oMMgfZMQthOryQo9n22dcuvvDin1pK8aKteLpeZ5c0A.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/content/fonts/roboto-font/oMMgfZMQthOryQo9n22dcuvvDin1pK8aKteLpeZ5c0A.woff2
// module id = 331
// module chunks = 0